const formatter = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "USD",
});

export const parseValueToMoney = (value: number): string =>
  formatter.format(value);
